import {
  HttpErrorResponse,
  HttpEventType,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, EMPTY, from, switchMap, tap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return from(authService.silentAuthRequest()).pipe(
    switchMap((result) => {
      const token = result.idToken;
      if (!token) {
        window.location.replace('/401');
        return EMPTY;
      }

      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(authReq).pipe(
        tap((event) => {
          if (event.type === HttpEventType.Response) {
            if (event.status === 401) {
            }
          }
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            router.navigate(['/401'], { replaceUrl: true });
            // window.location.replace('/401');
            return EMPTY;
          }

          return throwError(() => error);
        })
      );
    }),
    catchError((error) => {
      console.error('Token request error', error);
      return throwError(() => error);
    })
  );
};
